import {MeetingRepositoryForResident} from './MeetingRepositoryForResident'
import React, {Component, ReactNode} from 'react'
import {createResidentPage, ResidentPagePropsSet} from '../shared/hoc/createResidentPage'
import {getFileExtension, judgeAuthorityCheck, NatAsyncCallFunction} from '../../__NoAutomatedTests/common/util/Natutil'
import Meeting, {getManageAttendanceInfo} from './model/Meeting'
import {Nullable, Optional} from '../../app/TypeHelpers'
import {
    FullWidthColumnFlexContainer,
    FullWidthLeftRowFlexContainer,
    FullWidthRowFlexContainer,
    LeftColumnFlexContainer,
    LeftRowFlexContainer,
    LeftTopRowFlexContainer,
    RowFlexContainer,
} from '../../styledComponents/FlexComponents'
import {StyledLink} from '../../styledComponents/residentPage/Links'
import {
    FontAwesomeIconWrapper,
    getLinkIconComponent,
    IconBox,
    MeetingAttendanceDeadlineTag,
    MeetingIcon,
    MeetingIconBack,
    MiddleFontSpan,
    NewEllipsisText,
    PreWrap,
    TrashIcon,
} from './AssocDirectorCommon'
import {PlainBackLink} from '../../styledComponents/Links'
import {DisplayItemDividerForPageTop, DisplayItemTitle} from '../../styledComponents/DisplayItem'
import {Box, Collapse} from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import styled, {css} from 'styled-components'
import {Colors, FontSize, FontWeights} from '../../styledComponents/Constants'
import {currentMedia} from '../../styledComponents/ResponsiveConvenience'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faCalendarCheck, faClock, faCommentDots} from '@fortawesome/free-regular-svg-icons'
import {faExternalLinkAlt, faMapMarkerAlt} from '@fortawesome/free-solid-svg-icons'
import {ExpandButton, StyledCard, ViewOnlyModeMessage} from '../reservations/components/CommonStyle'
import NatCurrentDateTimeRepo
    from '../../__NoAutomatedTests/components/currentDateTime/repository/NatCurrentDateTimeRepo'
import {
    NatGetCurrentDateTime,
} from '../../__NoAutomatedTests/components/currentDateTime/repository/NatGetCurrentDateTime'
import moment, {Moment} from 'moment'
import {PlainLinkStyledButton} from '../../styledComponents/Button'
import NewMeetingComment from './model/NewMeetingComment'
import MeetingCommentInputForm, {
    ErrorMessage,
    ErrorMessageArea,
    ErrorMessageTitle,
    InputError,
} from './components/MeetingCommentInputForm'
import {MeetingCommentFile} from './model/MeetingCommentFile'
import MeetingAttendanceResponse from './model/MeetingAttendanceResponse'
import ResponsiveDialog from '../shared/ResponsiveDialog'
import ResidentRegisterMeetingAttendanceDialog from './ResidentRegisterMeetingAttendanceDialog'
import ResidentUpdateMeetingAttendanceDialog from './ResidentUpdateMeetingAttendanceDialog'
import ResidentMeetingAttendanceStatusTag from './ResidentMeetingAttendanceStatusTag'
import MeetingCommentView from './model/MeetingCommentView'
import Scroll from 'react-scroll'
import {MeetingWithComments} from './model/MeetingWithComments'
import {SubmitNewCommentProcedure} from './model/SubmitNewCommentProcedure'
import {MeetingHelper} from './utils/MeetingHelper'
import {HKConstants} from '../../HKConstants'
import BaseMeetingAttendanceResponse from './model/BaseMeetingAttendanceResponse'
import {ATTENDANCE_STATUS} from '../../CodeMaster'
import {ContentBody} from './AssocDirectorResidentCommon'
import {CommentNotificationData} from './model/CommentNotificationData'
import {AssocDirectorHelper} from './utils/AssocDirectorHelper'
import {Location} from 'react-router-dom'

const ScrollElement = Scroll.Element
const scroller = Scroll.scroller

interface LocationState {
    scrollTargetCommentId?: number
    previousPageUrl?: string
}

interface Props {
    condominiumCd: string
    meetingId: number
    meetingRepoForResident: MeetingRepositoryForResident
    currentDateTimeRepo: NatCurrentDateTimeRepo
    location: Location<LocationState>
}

interface State {
    meeting: Nullable<MeetingWithComments>
    isDescriptionOpen: boolean
    isPastMeeting: boolean
    meetingAttendance: Nullable<BaseMeetingAttendanceResponse>
    isAttendanceDialogOpen: boolean
    isCommentInputOpen: boolean
    newContent: string
    newCommentFileList: MeetingCommentFile[]
    commentInputError: Optional<InputError>
    errorCommentFileNameList: string[]
    errorCommentId: Nullable<number>
    havePostCommentAuthority: boolean
    currentDateTime: Nullable<Moment>
}

class ResidentMeetingDetailPage extends Component<Props & ResidentPagePropsSet, State> {
    submitNewCommentProcedure: SubmitNewCommentProcedure
    previousPageUrl: string

    constructor(props: Readonly<Props & ResidentPagePropsSet>) {
        super(props)

        this.previousPageUrl = props.location.state?.previousPageUrl ??
            `/resident/condominiums/${props.condominiumCd}/assoc-top`

        this.state = {
            meeting: null,
            isDescriptionOpen: true,
            isCommentInputOpen: false,
            isPastMeeting: false,
            meetingAttendance: null,
            isAttendanceDialogOpen: false,
            newContent: '',
            newCommentFileList: [],
            commentInputError: undefined,
            errorCommentFileNameList: [],
            errorCommentId: null,
            havePostCommentAuthority: false,
            currentDateTime: null,
        }

        this.handleClickCommentSubmitButton = this.handleClickCommentSubmitButton.bind(this)
        this.handleOpenMeetingAttendanceDialog = this.handleOpenMeetingAttendanceDialog.bind(this)
        this.handleCloseMeetingAttendanceDialog = this.handleCloseMeetingAttendanceDialog.bind(this)

        this.submitNewCommentProcedure = new SubmitNewCommentProcedure(
            (inputError) => {
                this.setState({
                    commentInputError: inputError,
                })
            },
            this.props.meetingRepoForResident,
            this.props.eventEmitter,
            this.props.navigate,
        )
    }

    async componentDidMount(): Promise<void> {
        const [meeting, currentDateTime] =
            await Promise.all([this.getMeeting(), this.getCurrentDateTime()])
        if (meeting === null) {
            return
        }
        if (currentDateTime === null || currentDateTime.details === null) {
            return
        }

        const isPastMeeting = MeetingHelper.checkPastMeeting(meeting, moment(currentDateTime.details.currentDateTime))

        let meetingAttendance: Nullable<BaseMeetingAttendanceResponse | 'Observer'> = null
        const manageAttendanceInfo = getManageAttendanceInfo(meeting)
        if (manageAttendanceInfo
            && manageAttendanceInfo.attendanceReplyRequestDatetime !== null) {
            meetingAttendance = await this.getAttendance()
            if (meetingAttendance === null) {
                return
            }
        }

        this.setState({
                meeting,
                isDescriptionOpen: !isPastMeeting,
                isPastMeeting: isPastMeeting,
                meetingAttendance: meetingAttendance === 'Observer' ? null : meetingAttendance,
                havePostCommentAuthority: judgeAuthorityCheck(HKConstants.CMN.AUTH.POST_COMMENT_ASSOC_DIRECTOR),
                currentDateTime: moment(currentDateTime.details.currentDateTime),
            },
            () => {
                const targetId = this.props.location.state?.scrollTargetCommentId
                if (targetId) {
                    scroller.scrollTo(`comment-${targetId}`, {
                        delay: 100,
                        duration: 500,
                        smooth: true,
                    })
                }
            })
    }

    async getMeeting(): Promise<Nullable<MeetingWithComments>> {
        const {meetingRepoForResident, condominiumCd, navigate, meetingId} = this.props

        let meeting: Nullable<MeetingWithComments> = null
        await this.props.eventEmitter.showLoading()
        try {
            meeting = await NatAsyncCallFunction(
                meetingRepoForResident.getMeetingWithComments.bind(
                    meetingRepoForResident,
                    condominiumCd,
                    meetingId,
                ), navigate)
        } finally {
            this.props.eventEmitter.closeLoading()
        }

        return meeting
    }

    async getCurrentDateTime(): Promise<Nullable<NatGetCurrentDateTime>> {
        const {currentDateTimeRepo, navigate} = this.props

        await this.props.eventEmitter.showLoading()
        let currentDateTime: Nullable<NatGetCurrentDateTime> = null
        try {
            currentDateTime = await NatAsyncCallFunction(
                currentDateTimeRepo.getCurrentDateTime.bind(currentDateTimeRepo),
                navigate,
            )
        } finally {
            this.props.eventEmitter.closeLoading()
        }
        return currentDateTime
    }

    async getAttendance(): Promise<Nullable<BaseMeetingAttendanceResponse | 'Observer'>> {
        const {meetingRepoForResident, condominiumCd, navigate, meetingId} = this.props

        let meetingAttendance: Nullable<BaseMeetingAttendanceResponse | 'Observer'> = null
        await this.props.eventEmitter.showLoading()
        try {
            meetingAttendance = await NatAsyncCallFunction(
                meetingRepoForResident.getAttendance.bind(
                    meetingRepoForResident,
                    condominiumCd,
                    meetingId,
                ), navigate)
        } finally {
            this.props.eventEmitter.closeLoading()
        }

        return meetingAttendance
    }

    handleClickDescriptionTitle = (): void => {
        this.setState({isDescriptionOpen: !this.state.isDescriptionOpen})
    }

    handleClickOpenCommentInputButton = (): void => {
        this.setState({isCommentInputOpen: true})
    }

    handleChangeCommentInput = (
        content: string,
        commentFileList: MeetingCommentFile[],
        deleteFileNumberList: number[],
        errorMessage?: InputError,
    ): void => {
        this.setState({
            newContent: content,
            newCommentFileList: commentFileList,
            commentInputError: errorMessage,
        })
    }

    handleClickCloseCommentInputButton = (): void => {
        this.setState({
            newContent: '',
            newCommentFileList: [],
            isCommentInputOpen: false,
            commentInputError: undefined,
            errorCommentFileNameList: [],
            errorCommentId: null,
        })
    }

    async handleClickCommentSubmitButton(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            const {condominiumCd, meetingId} = this.props
            const {newContent, newCommentFileList} = this.state

            const commentId = await this.submitNewCommentProcedure.submit(
                condominiumCd,
                meetingId,
                new NewMeetingComment(newContent),
                newCommentFileList,
            )
            if (!commentId) {
                return
            }
            const commentNotificationData: CommentNotificationData = {
                meetingId: meetingId,
                commentId: commentId,
            }
            this.props.meetingRepoForResident.sendCommentNotification(
                condominiumCd,
                commentNotificationData,
            ).then(r => null)

            const meeting = await this.getMeeting()
            if (meeting === null) {
                return
            }

            const fileUploadError = this.submitNewCommentProcedure.getFileUploadError()
            this.setState({
                meeting: meeting,
                isCommentInputOpen: false,
                newContent: '',
                newCommentFileList: [],
                commentInputError: undefined,
                errorCommentFileNameList: fileUploadError?.errorFileNameList ?? [],
                errorCommentId: fileUploadError?.commentId ?? null,
            })
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    handleOpenMeetingAttendanceDialog(): void {
        this.setState({isAttendanceDialogOpen: true})
    }

    async handleCloseMeetingAttendanceDialog(isOk: boolean): Promise<void> {
        if (isOk) {
            const attendance = await this.getAttendance()
            if (attendance === null) {
                return
            }

            this.setState({
                meetingAttendance: attendance === 'Observer' ? null : attendance,
                isAttendanceDialogOpen: false,
            })
        } else {
            this.setState({isAttendanceDialogOpen: false})
        }
    }

    handleClickCommentCard = (meetingCommentId: number) => (): void => {
        const {condominiumCd, meetingId, navigate} = this.props
        const previousPageUrlStack = []
        previousPageUrlStack.push(this.previousPageUrl)
        previousPageUrlStack.push(`/resident/condominiums/${condominiumCd}/meetings/${meetingId}`)

        navigate(
            `/resident/condominiums/${condominiumCd}/meetings/${meetingId}/comments/${meetingCommentId}/reply`,
            {state: {previousPageUrlStack}},
        )
    }

    renderNotRegisteredMessage(message: string): ReactNode {
        return <FullWidthColumnFlexContainer>
            <NotRegistered>{message}</NotRegistered>
        </FullWidthColumnFlexContainer>
    }

    renderMeetingAttendance(meeting: Meeting, meetingAttendance: Nullable<BaseMeetingAttendanceResponse>): ReactNode {
        const {isPastMeeting} = this.state
        const manageAttendanceInfo = getManageAttendanceInfo(meeting)

        if (manageAttendanceInfo === null
            || manageAttendanceInfo.attendanceReplyRequestDatetime === null) {
            return null
        }

        if (meetingAttendance === null) {
            return null
        }

        const isUnanswered = meetingAttendance.attendanceStatus === ATTENDANCE_STATUS.UNANSWERED
        if (isPastMeeting && isUnanswered) {
            return null
        }

        let statusNode: ReactNode
        let buttonLabel: string

        if (!isUnanswered) {
            statusNode =
                <ResidentMeetingAttendanceStatusTag meetingAttendanceStatus={meetingAttendance.attendanceStatus}/>
            buttonLabel = isPastMeeting ? '確認する' : '変更する'
        } else {
            statusNode = <>
                <div>出欠回答</div>
                <Box width={'5px'}/>
                <MeetingAttendanceDeadlineTag>
                    {manageAttendanceInfo.attendanceReplyDeadline.format('M/D')}まで
                </MeetingAttendanceDeadlineTag>
            </>
            buttonLabel = '回答する'
        }

        return <>
            <Box height={'5px'}/>
            <MiddleFontSpan>
                <RowFlexContainer>
                    <LeftRowFlexContainer>
                        <IconBox><FontAwesomeIcon icon={faCalendarCheck}/></IconBox>
                        {statusNode}
                    </LeftRowFlexContainer>
                    <PlainLinkStyledButton onClick={this.handleOpenMeetingAttendanceDialog}>
                        {buttonLabel}
                    </PlainLinkStyledButton>
                </RowFlexContainer>
            </MiddleFontSpan>
        </>
    }

    renderDescription(meeting: Meeting, meetingAttendance: Nullable<BaseMeetingAttendanceResponse>): ReactNode {
        return (<>
            <MiddleFontSpan>
                <LeftTopRowFlexContainer>
                    <IconBox><FontAwesomeIcon icon={faMapMarkerAlt}/></IconBox>
                    {MeetingHelper.getMeetingPlaceString(meeting)}
                </LeftTopRowFlexContainer>
            </MiddleFontSpan>
            {this.renderMeetingAttendance(meeting, meetingAttendance)}
            <Box height={'20px'}/>
            {
                meeting.memo && <>
                    <MeetingMemo>
                        {meeting.memo}
                    </MeetingMemo>
                    <Box height={'15px'}/>
                </>
            }
            {
                meeting.url && <FullWidthColumnFlexContainer>
                    <JoinOnlineMeetingButton href={meeting.url} target={'_blank'} rel={'noopener noreferrer'}>
                        オンライン会議に参加する
                    </JoinOnlineMeetingButton>
                    <Box height={'20px'}/>
                </FullWidthColumnFlexContainer>
            }
        </>)
    }

    renderMeetingFile(meeting: Meeting): ReactNode {
        if (
            meeting.meetingAttachmentFileList.length === 0 &&
            meeting.meetingAttachmentLinkList.length === 0
        ) {
            return (<>
                <Box height={'5px'}/>
                {this.renderNotRegisteredMessage('登録されていません')}
            </>)
        }

        return <LeftColumnFlexContainer>
            {
                meeting.meetingAttachmentFileList.map((attachment, index) => {
                    return <div key={`file-${index}`}>
                        <Box height={'5px'}/>
                        <DocumentLink to={attachment.uri}>
                            <LeftTopRowFlexContainer>
                                <DocumentIconBox>
                                    {getLinkIconComponent(getFileExtension(attachment.displayName))}
                                </DocumentIconBox>
                                {attachment.displayName}
                            </LeftTopRowFlexContainer>
                        </DocumentLink>
                    </div>
                })
            }
            {
                meeting.meetingAttachmentLinkList.map((attachment, index) => {
                    return <div key={`link-${index}`}>
                        <Box height={'5px'}/>
                        <DocumentLink
                            href={attachment.uri}
                            target={'_blank'}
                            rel={'noopener noreferrer'}
                        >
                            <LeftTopRowFlexContainer>
                                <DocumentIconBox>
                                    <FontAwesomeIcon icon={faExternalLinkAlt}/>
                                </DocumentIconBox>
                                {attachment.displayName}
                            </LeftTopRowFlexContainer>
                        </DocumentLink>
                    </div>
                })
            }
        </LeftColumnFlexContainer>
    }

    renderReport(meeting: Meeting): ReactNode {
        if (meeting.meetingReportList.length === 0) {
            return (<>
                <Box height={'5px'}/>
                {this.renderNotRegisteredMessage('登録されていません')}
            </>)
        }

        return <LeftColumnFlexContainer>
            {
                meeting.meetingReportList.map((attachment, index) => {
                    return <div key={`report-${index}`}>
                        <Box height={'5px'}/>
                        <DocumentLink to={attachment.uri}>
                            <LeftTopRowFlexContainer>
                                <DocumentIconBox>
                                    {getLinkIconComponent(getFileExtension(attachment.displayName))}
                                </DocumentIconBox>
                                {attachment.displayName}
                            </LeftTopRowFlexContainer>
                        </DocumentLink>
                    </div>
                })
            }
        </LeftColumnFlexContainer>
    }

    renderMeetingViewComment(meeting: MeetingWithComments, currentDateTime: Moment): ReactNode {
        const {errorCommentId, errorCommentFileNameList} = this.state
        return <MeetingCardList>{
            meeting.meetingCommentList.map((comment, index) => {
                let displayLatestReplyDatetime = ''
                if (comment.latestReplyDatetime !== null) {
                    const targetDateTimeMoment = currentDateTime.clone().subtract(7, 'days')
                    const latestReplyDatetimeMomoment = moment(comment.latestReplyDatetime!)
                    if (targetDateTimeMoment.isSameOrBefore(latestReplyDatetimeMomoment)) {
                        displayLatestReplyDatetime = moment(comment.latestReplyDatetime!).fromNow() + 'に返信あり'
                    }
                }

                return <StyledScrollElement key={`comment-${index}`} name={`comment-${comment.meetingCommentId}`}>
                    <Box height={'15px'}/>
                    <MeetingCard
                        onClick={this.handleClickCommentCard(comment.meetingCommentId)}
                    >
                        {
                            comment instanceof MeetingCommentView ?
                                <>
                                    <FullWidthRowFlexContainer>
                                        {MeetingHelper.getUserIconNodeByResidentStatus(
                                            comment.user.isWithinTerm,
                                            comment.user.hasMailAddress,
                                            comment.user.role,
                                            comment.user.roomList,
                                            'small')}
                                        <UserInformationArea>
                                            <CardHeaderInformationSpan>
                                                {AssocDirectorHelper.getDisplayUserNameByResidentStatus(
                                                    comment.user.familyName,
                                                    comment.user.firstName,
                                                    comment.user.roomList,
                                                )}
                                            </CardHeaderInformationSpan>
                                            <Box width={8}/>
                                            <CardHeaderDateTimeSpan>
                                                {MeetingHelper.formatDoNotDisplayCurrentYear(
                                                    currentDateTime.format('YYYY-MM-DDTHH:mm:ss'),
                                                    comment.updateDatetime,
                                                )}
                                            </CardHeaderDateTimeSpan>
                                        </UserInformationArea>
                                    </FullWidthRowFlexContainer>
                                    <Box height={'5px'}/>
                                    <NewEllipsisText lineHeightInPixel={36} numOfLines={3}>
                                        <PreWrap>
                                            {comment.content}
                                        </PreWrap>
                                    </NewEllipsisText>
                                </>
                                :
                                <>
                                    <FullWidthLeftRowFlexContainer>
                                        <TrashIcon width={'20px'} iconSize={'12px'}></TrashIcon>
                                        <Box ml={'5px'}>
                                            <CardHeaderInformationSpan>
                                                このコメントは削除されました。
                                            </CardHeaderInformationSpan>
                                        </Box>
                                    </FullWidthLeftRowFlexContainer>
                                </>
                        }
                        <CardFooterArea>
                            <span>{displayLatestReplyDatetime}</span>
                            <RowFlexContainer>
                                <FontAwesomeIconWrapper
                                    icon={faCommentDots}
                                    iconSize={'20px'}
                                    iconColor={Colors.AccentDark}
                                />
                                <Box ml={'5px'}>
                                    {comment.replyCount}
                                </Box>
                            </RowFlexContainer>
                        </CardFooterArea>
                        {
                            comment.meetingCommentId === errorCommentId &&
                            errorCommentFileNameList &&
                            errorCommentFileNameList.length > 0 &&
                            <ErrorMessageArea>
                                <ErrorMessageTitle>
                                    資料のアップロードに失敗しました。
                                </ErrorMessageTitle>
                                <Box height={'5px'}/>
                                <ErrorMessage>
                                    アップロードの最中に問題が発生しました。<br/>
                                    編集から再度アップロードしてください。
                                </ErrorMessage>
                                <Box height={'10px'}/>
                                {
                                    errorCommentFileNameList.map((fileName, errorFileIndex) => {
                                        return <ErrorMessage key={'errorFileName-' + errorFileIndex}>
                                            {fileName}
                                        </ErrorMessage>
                                    })
                                }
                            </ErrorMessageArea>
                        }
                    </MeetingCard>
                </StyledScrollElement>
            })
        }</MeetingCardList>
    }

    renderMeetingCommentInputArea(): ReactNode {
        const {newContent, newCommentFileList, commentInputError} = this.state
        return <MeetingCommentInputForm
            submitButtonLabel={'投稿する'}
            onClickSubmitButton={this.handleClickCommentSubmitButton}
            onClickCancelButton={this.handleClickCloseCommentInputButton}
            onChange={this.handleChangeCommentInput}
            content={newContent}
            placeholder={'新しいコメントを入力...'}
            commentFileList={newCommentFileList}
            deleteFileNumberList={[]}
            inputError={commentInputError}
        />
    }

    render(): ReactNode {
        const {condominiumCd, meetingId, meetingRepoForResident, navigate, eventEmitter} = this.props
        const {
            meeting,
            isCommentInputOpen,
            isPastMeeting,
            meetingAttendance,
            isAttendanceDialogOpen,
            havePostCommentAuthority,
            currentDateTime,
        } = this.state
        if (meeting === null || currentDateTime === null) {
            return null
        }

        const meetingDateString = MeetingHelper.getMeetingDateString(meeting)

        const manageAttendanceInfo = getManageAttendanceInfo(meeting)

        return (<>
            <PlainBackLink to={this.previousPageUrl}>
                戻る
            </PlainBackLink>
            <Box height={'14px'}/>
            <DisplayItemDividerForPageTop/>
            <Box height={'15px'}/>
            <ContentBody>
                {
                    !havePostCommentAuthority &&
                    <>
                        <ViewOnlyModeMessage>コメントを投稿する権限がありません。</ViewOnlyModeMessage>
                        <Box height={'15px'}/>
                    </>
                }
                <WideWhiteArea>
                    <Box height={'17px'}/>
                    <LeftRowFlexContainer>
                        <MeetingIconBack><MeetingIcon/></MeetingIconBack>
                        <Box minWidth={'10px'}/>
                        <MeetingTitle>{meeting.name}</MeetingTitle>
                    </LeftRowFlexContainer>
                    <Box height={'11px'}/>
                    <DescriptionHeadline onClick={this.handleClickDescriptionTitle}>
                        <Caption>開催要項</Caption>
                        <SmallExpandButton open={this.state.isDescriptionOpen}/>
                    </DescriptionHeadline>
                    <Box height={'10px'}/>
                    <Collapse in={this.state.isDescriptionOpen}>
                        <LeftRowFlexContainer>
                            <IconBox><FontAwesomeIcon icon={faClock}/></IconBox>
                            {meetingDateString}
                        </LeftRowFlexContainer>
                        <Box height={'5px'}/>
                        {this.renderDescription(meeting, meetingAttendance)}
                    </Collapse>
                </WideWhiteArea>
                <Box height={'10px'}/>
                <WideWhiteArea>
                    <Box height={'10px'}/>
                    <Caption>議題・アジェンダ</Caption>
                    <Box height={'5px'}/>
                    {
                        meeting.contents !== null &&
                        <PreWrap>{meeting.contents}</PreWrap>
                    }
                    {
                        meeting.contents === null &&
                        this.renderNotRegisteredMessage('登録されていません')
                    }
                    <Box height={'15px'}/>
                </WideWhiteArea>
                <Box height={'5px'}/>
                <WideWhiteArea>
                    <Box height={'10px'}/>
                    <Caption>資料</Caption>
                    {this.renderMeetingFile(meeting)}
                    <Box height={'15px'}/>
                </WideWhiteArea>
                <Box height={'5px'}/>
                <WideWhiteArea>
                    <Box height={'10px'}/>
                    <Caption>議事録</Caption>
                    {this.renderReport(meeting)}
                    <Box height={'15px'}/>
                </WideWhiteArea>
                <Box height={'35px'}/>
            </ContentBody>
            <DisplayItemTitle>コメント</DisplayItemTitle>
            <CommentArea>
                <Box height={'5px'}/>
                {
                    havePostCommentAuthority &&
                    <InputCommentArea>
                        <InputCommentContainer>
                            <Box height={'15px'}/>
                            {
                                isCommentInputOpen ? this.renderMeetingCommentInputArea() :
                                    <NewCommentButton onClick={this.handleClickOpenCommentInputButton}>
                                        新しいコメントを入力...
                                    </NewCommentButton>
                            }
                            <Box height={'15px'}/>
                        </InputCommentContainer>
                    </InputCommentArea>
                }
                {this.renderMeetingViewComment(meeting, currentDateTime)}
                {
                    manageAttendanceInfo &&
                    manageAttendanceInfo.proxyAttendanceAvailability &&
                    <ResponsiveDialog
                        id={'pp-dialog'}
                        open={isAttendanceDialogOpen}
                        transitionDuration={(process.env.NODE_ENV === 'test') ? 0 : undefined}
                        maxWidth={'sm'}
                        fullWidth
                    >
                        {
                            meetingAttendance instanceof MeetingAttendanceResponse ?
                                <ResidentUpdateMeetingAttendanceDialog
                                    condominiumCd={condominiumCd}
                                    meetingId={meetingId}
                                    meetingName={meeting.name}
                                    meetingDateString={meetingDateString}
                                    meetingPlaceString={MeetingHelper.getMeetingPlaceString(meeting)}
                                    proxyAttendanceAvailability={manageAttendanceInfo.proxyAttendanceAvailability}
                                    meetingAttendance={meetingAttendance}
                                    readOnly={isPastMeeting}
                                    meetingRepo={meetingRepoForResident}
                                    eventEmitter={eventEmitter}
                                    navigate={navigate}
                                    onClose={this.handleCloseMeetingAttendanceDialog}
                                /> // TODO リファクタリング meeting関連情報をまとめる
                                :
                                <ResidentRegisterMeetingAttendanceDialog
                                    condominiumCd={condominiumCd}
                                    meetingId={meetingId}
                                    meetingName={meeting.name}
                                    meetingDateString={meetingDateString}
                                    meetingPlaceString={MeetingHelper.getMeetingPlaceString(meeting)}
                                    proxyAttendanceAvailability={manageAttendanceInfo.proxyAttendanceAvailability}
                                    meetingRepo={meetingRepoForResident}
                                    eventEmitter={eventEmitter}
                                    navigate={navigate}
                                    onClose={this.handleCloseMeetingAttendanceDialog}
                                />
                        }
                    </ResponsiveDialog>
                }
            </CommentArea>
            <Box height={'15px'}/>
        </>)
    }
}

export default createResidentPage(ResidentMeetingDetailPage)

const WideWhiteArea = styled.div`
  background-color: ${Colors.Surface};
  ${currentMedia.lessThan('sp')`
    width: calc(100% + 30px);
    margin: 0px -15px;
  `};
  padding: 0 15px;
  box-sizing: border-box;
  overflow: hidden;
`

const MeetingTitle = styled.span`
  font-weight: ${FontWeights.Bold};
`

const Caption = styled.div`
  font-size: ${FontSize.Small};
  color: ${Colors.AccentDark};
`

const MeetingMemo = styled(PreWrap)`
  font-size: ${FontSize.Middle};
`

const NotRegistered = styled.div`
  font-size: ${FontSize.Middle};
  color: ${Colors.AccentDark};
`

const StyledButton = css`
  height: 50px;
  width: 345px;
  max-width: 384px;

  box-sizing: border-box;

  display: flex;
  justify-content: center;
  align-items: center;

  color: ${Colors.Primary};
  text-decoration: none;
  background-color: transparent;

  font-size: ${FontSize.Body};
  font-weight: ${FontWeights.Normal};

  border: 1px solid rgba(0, 112, 176, 0.5);
  border-radius: 8px;
  box-shadow: none;

  :active {
    background-color: ${Colors.SecondaryActive};
  }
`

const JoinOnlineMeetingButton = styled.a`
  ${StyledButton}
`

const DocumentLink = withStyles({
    root: {
        color: Colors.Primary,
        fontSize: FontSize.Body,
        lineHeight: 1.5,
    },
})(StyledLink)

const DocumentIconBox = styled(IconBox)`
  color: ${Colors.AccentDark};
`

const SmallExpandButton = styled(ExpandButton)`
  transform: scale(0.7, 0.7);
`

const DescriptionHeadline = styled(RowFlexContainer)`
  &:hover {
    cursor: pointer;
  }
`

const NewCommentButton = styled.button`
  border: ${Colors.AccentLight} 1px solid;
  border-radius: 4px;
  padding: 8px 10px;
  box-sizing: border-box;
  width: 100%;

  font-size: ${FontSize.Body};
  color: ${Colors.Placeholder};
  font-weight: ${FontWeights.Normal};
  line-height: 1.5;
  text-align: start;
  background-color: ${Colors.Surface};
`

const MeetingCardList = styled.div`
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

const MeetingCard = styled(StyledCard)`
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  justify-content: left;
  width: 100%;
  box-shadow: 0 1px 8px rgba(112, 112, 112, 0.4);
  padding: 15px;
  ${currentMedia.lessThan('sp')`
    max-width: 384px;
  `}
  ${currentMedia.greaterThan('pc')`
    align-items: stretch;
  `}
`

const CommentArea = styled(ContentBody)`
  max-width: 600px;
`

const InputCommentArea = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
`

const InputCommentContainer = styled(FullWidthColumnFlexContainer)`
  ${currentMedia.lessThan('sp')`
    max-width: 384px;
  `}
`

const UserInformationArea = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-left: 5px;
`

const StyledScrollElement = styled(ScrollElement)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

const CardFooterArea = styled.div`
  margin-top: 10px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: ${Colors.AccentDark};
  font-size: 12px;
`

const CardHeaderInformationSpan = styled.span`
  font-size: 14px;
`

const CardHeaderDateTimeSpan = styled.span`
  font-size: 14px;
  white-space: nowrap;
`
